export default __webpack_public_path__ + "static/media/practica_personalizada.e8a7c652.png";